import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Select,
  Table,
  Thead,
  Tbody,
  Tr,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Th,
  Td,
  Text,
  Stack,
  IconButton,
  useDisclosure,
  Input,
  useToast,
  Badge,
  keyframes,
} from "@chakra-ui/react";
import { EditIcon, DeleteIcon } from "@chakra-ui/icons";

import Edit_BookList from "./Edit_BookList";
import { BASE_URL } from "../../../../Globalapi/Globalapi";

const BookList = () => {
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const toast = useToast();
  const [bookToDelete, setBookToDelete] = useState(null); // Track the book to be deleted
  const schoolId = sessionStorage.getItem("school_id");
  const userId = sessionStorage.getItem("user_id");
  const { isOpen, onOpen, onClose } = useDisclosure(); // Modal hooks
  const apiUrl = `${BASE_URL}/admin/library/books/list_books.php?school_id=${schoolId}`;

  const categoryApiUrl = `${BASE_URL}/admin/library/category/list_category.php?school_id=${schoolId}`;

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  const currentData = filteredData.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // Fetch books
  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await fetch(apiUrl);
        console.log("listtt book", response);

        const result = await response.json();
        console.log("res", result);

        if (result.success) {
          setData(result.data || []);
          setFilteredData(result.data || []);
        } else {
          setError(result.message || "Failed to fetch data");
        }
      } catch (err) {
        setError("Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(categoryApiUrl);

        const result = await response.json();

        if (result.success) {
          setCategories(result.data || []);
        } else {
          console.error("Failed to fetch categories");
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };

    fetchCategories();
  }, []);

  // Handle filter and search
  useEffect(() => {
    let filtered = data;

    if (selectedCategory) {
      filtered = filtered.filter(
        (book) => book.category_name === selectedCategory
      );
    }

    if (searchQuery) {
      filtered = filtered.filter((book) =>
        book.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    setFilteredData(filtered);
  }, [selectedCategory, searchQuery, data]);

  const handleEdit = (bookId) => {
    toast({
      title: `Editing book ID: ${bookId}`,
      status: "info",
      duration: 3000,
      isClosable: true,
    });
  };

  // Open delete confirmation modal
  const handleDeleteOpen = (bookId) => {
    setBookToDelete(bookId); // Set the book ID for deletion
    onOpen(); // Open the modal
  };

  // Handle delete action
  const handleDelete = async () => {
    const bookId = bookToDelete;
    if (bookId) {
      try {
        const dataToDelete = {
          user_id: userId,
          school_id: schoolId,
          book_id: bookId,
        };

        const response = await fetch(
          `${BASE_URL}/admin/library/books/delete_book.php`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDelete),
          }
        );

        const result = await response.json();

        if (result.success) {
          setData(data.filter((book) => book.id !== bookId));
          toast({
            title: "Book deleted successfully.",
            status: "success",
            duration: 3000,
            isClosable: true,
          });
        } else {
          toast({
            title: result.message || "Failed to delete book.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      } catch (error) {
        toast({
          title: "Failed to delete book.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      } finally {
        onClose(); // Close the modal after the delete attempt
      }
    }
  };

  const isNewBook = (createdAt) => {
    console.log("cre", createdAt);

    const currentDate = new Date();
    const createdDate = new Date(createdAt);
    const differenceInDays =
      (currentDate - createdDate) / (1000 * 60 * 60 * 24);
    console.log("dif", differenceInDays);

    return differenceInDays <= 12;
  };

  const blink = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
`;
  return (
    <Box overflowX="auto" p={5}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        // mb={1}
        p={3}
        // p={{base:"2",md:"3"}}
        className="sb"
      >
        {/* Rows Per Page */}
        <Flex align="center" mb={{ base: 4, md: 0 }}>
          <Text mr={2}>Rows Per Page</Text>
          <Select
            width="120px"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </Select>
        </Flex>

        {/* Search and Filters on the Right */}
        <Flex
          direction={{ base: "column", md: "row" }}
          align="center"
          ml={{ md: "auto" }}
        >
          <Flex align="center" mb={{ base: 4, md: 0 }} mr={{ md: 4 }}>
            <Select
              width="230px"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">Categories</option>
              {categories.map((category) => (
                <option key={category.id} value={category.name}>
                  {category.name}
                </option>
              ))}
            </Select>
          </Flex>
          <Flex align="center">
            <Input
              width="230px"
              placeholder="Search by Book Name"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Flex>
        </Flex>
      </Flex>

      {loading ? (
        <Text>Loading...</Text>
      ) : error ? (
        <Text color="red.500">{error}</Text>
      ) : (
        <Box overflowX="auto" maxWidth="100%">
          <Table
            sx={{
              "tbody tr:nth-of-type(even)": { backgroundColor: "#f2f4f8" },
              "th, td": {
                textAlign: "center",
              },
            }}
          >
            <Thead>
              <Tr>
                <Th>Book Name</Th>
                <Th>Author</Th>
                <Th>Publisher</Th>
                <Th>ISBN</Th>
                <Th>Category</Th>
                <Th>Available Copies</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentData.length > 0 ? (
                currentData.map((row) => (
                  <Tr key={row.id}>
                    <Td position="relative">
                      <Box position="relative">
                        {row.title}
                        {isNewBook(row.created_at) && (
                          <Badge
                            bgGradient="linear(to-r, teal.400, blue.500)" // Gradient background
                            color="white" // Text color
                            position="relative"
                            bottom="2.5"
                            left="2.5"
                            animation={`${blink} 1.5s infinite`}
                            px={3} // Wider padding for a different look
                            py={0.5}
                            fontSize="0.6em"
                            borderRadius="md" // Rounded rectangle instead of full circle
                            boxShadow="0 2px 4px rgba(0, 0, 0, 0.2)" // Adds depth
                          >
                            New
                          </Badge>
                        )}
                      </Box>
                    </Td>
                    <Td>{row.author}</Td>
                    <Td>{row.publisher}</Td>
                    <Td>{row.isbn}</Td>
                    <Td>{row.category_name}</Td>
                    <Td>{row.available_copies}</Td>
                    <Td>
                      <Stack
                        direction="row"
                        spacing={2}
                        justify="center"
                        align="center"
                      >
                        <Edit_BookList bookId={row.id} />
                        <IconButton
                          icon={<DeleteIcon />}
                          onClick={() => handleDeleteOpen(row.id)} // Open delete modal
                          aria-label="Delete Book"
                          colorScheme="red"
                          size="sm"
                        />
                      </Stack>
                    </Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan="8" textAlign="center">
                    No books available
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Box>
      )}

      {/* Pagination Controls */}
      <Flex justify="end" borderTopWidth="1px" p={3} className="sb2">
        <Button
          onClick={() => handlePageChange(currentPage - 1)}
          isDisabled={currentPage === 1}
        >
          Prev
        </Button>
        <Stack direction="row" mx={2}>
          {currentPage > 1 && (
            <>
              <Button onClick={() => handlePageChange(1)}>1</Button>
              {currentPage > 2 && <Text>...</Text>}
            </>
          )}
          <Button backgroundColor="teal" color="white">
            {currentPage}
          </Button>
          {currentPage < totalPages && (
            <>
              {currentPage < totalPages - 1 && <Text>...</Text>}
              <Button onClick={() => handlePageChange(totalPages)}>
                {totalPages}
              </Button>
            </>
          )}
        </Stack>
        <Button
          onClick={() => handlePageChange(currentPage + 1)}
          isDisabled={currentPage === totalPages}
        >
          Next
        </Button>
      </Flex>

      {/* Delete Confirmation Modal */}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Book Issue</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>Are you sure you want to delete this book issue?</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="gray" mr={3} onClick={onClose}>
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleDelete}>
              Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default BookList;
